import { render, staticRenderFns } from "./Trustami.vue?vue&type=template&id=0dab9dc6&scoped=true"
import script from "./Trustami.vue?vue&type=script&lang=js"
export * from "./Trustami.vue?vue&type=script&lang=js"
import style0 from "./Trustami.vue?vue&type=style&index=0&id=0dab9dc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dab9dc6",
  null
  
)

export default component.exports